import React from 'react'

import Page from '../components/Page'
import LazyImage from '../components/LazyImage'

export default function CommunityChoiceVoting (props) {
  const {
    ccv_intro_heading: introHeading,
    ccv_intro_copy: introCopy,

    ccv_instructions_heading: instructionsHeading,
    ccv_instructions_copy: instructionsCopy,
    ccv_voting_open: votingOpen,
    ccv_voting_close: votingClose,

    ccv_films_heading: filmsHeading,
    ccv_films: films = [],

    ccv_faq_heading: faqHeading,
    ccv_faqs: faqs = [],

    ccv_connected_heading: connectedHeading,
    ccv_connected_copy: connectedCopy,

    ccv_donation_url: donationUrl
  } = props.acf || {}

  const hasIntro = introHeading || introCopy

  const hasVotingIntro =
    instructionsHeading || instructionsCopy || votingOpen || votingClose

  const hasFilms = filmsHeading || films.length > 0

  const hasFaqs = faqHeading || faqs.length > 0

  const hasConnected = connectedHeading || connectedCopy

  return (
    <Page
      title='Community Choice Voting'
      body={introCopy}
      slug='/community-choice-voting'
    >
      <main id='content'>
        {hasIntro && (
          <section className='community-intro'>
            <div className='container-fluid'>
              <div className='row justify-content-center'>
                <div className='col-10'>
                  {introHeading && <h2 className='heading2'>{introHeading}</h2>}

                  {introCopy && (
                    <div
                      className='community-intro__copy'
                      dangerouslySetInnerHTML={{
                        __html: introCopy
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
        )}

        {hasVotingIntro && (
          <section className='community-voting-intro'>
            <div className='container-fluid'>
              <div className='row justify-content-center'>
                <div className='col-10'>
                  {instructionsHeading && (
                    <h2 className='heading2'>{instructionsHeading}</h2>
                  )}

                  {instructionsCopy && (
                    <div
                      className='community-voting-intro__copy'
                      dangerouslySetInnerHTML={{
                        __html: instructionsCopy
                      }}
                    />
                  )}

                  {(votingOpen || votingClose) && (
                    <div className='voting-dates'>
                      {votingOpen && (
                        <p>
                          <strong>Community Voting Opens:</strong> {votingOpen}
                        </p>
                      )}

                      {votingClose && (
                        <p>
                          <strong>Community Voting Closes:</strong>{' '}
                          {votingClose}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}

        {hasFilms && (
          <section className='community-films'>
            <div className='container-fluid'>
              <div className='row justify-content-center'>
                <div className='col-10'>
                  {filmsHeading && <h2 className='heading2'>{filmsHeading}</h2>}

                  {films.length > 0 && (
                    <div className='link-columns'>
                      <div className='row'>
                        {films.map((film, index) => {
                          const filmKey =
                            film.title ||
                            film.youtube_url ||
                            film.vote_url ||
                            index

                          return (
                            <div
                              className='col-12 col-md-6 col-lg-4 link-column'
                              key={filmKey}
                            >
                              {film.image?.url && (
                                <LazyImage
                                  background
                                  imageClass='link-column__image'
                                  src={film.image.url}
                                />
                              )}

                              <div className='link-column__text'>
                                {film.title && (
                                  <h3 className='heading3'>{film.title}</h3>
                                )}

                                {(film.youtube_url || film.vote_url) && (
                                  <div>
                                    {film.youtube_url && (
                                      <a
                                        href={film.youtube_url}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        className='link'
                                      >
                                        View Film
                                      </a>
                                    )}

                                    {film.vote_url && (
                                      <a
                                        href={film.vote_url}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        className='link'
                                      >
                                        Vote
                                      </a>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}

        {hasFaqs && (
          <section className='community-faqs'>
            <div className='container-fluid'>
              <div className='row justify-content-center'>
                <div className='col-10'>
                  {faqHeading && <h2 className='heading2'>{faqHeading}</h2>}

                  {faqs.map((faq, index) => {
                    const faqKey = faq.question || index

                    return (
                      <div className='faq-item' key={faqKey}>
                        {faq.question && (
                          <h3 className='p-body'>{faq.question}</h3>
                        )}

                        {faq.answer && (
                          <div
                            className='faq-item__answer'
                            dangerouslySetInnerHTML={{
                              __html: faq.answer
                            }}
                          />
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </section>
        )}

        {hasConnected && (
          <section className='community-connected'>
            <div className='container-fluid'>
              <div className='row justify-content-center'>
                <div className='col-10'>
                  {connectedHeading && (
                    <h2 className='heading2'>{connectedHeading}</h2>
                  )}

                  {connectedCopy && (
                    <div
                      className='community-connected__copy'
                      dangerouslySetInnerHTML={{
                        __html: connectedCopy
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
        )}

        {donationUrl && (
          <section className='community-donate'>
            <div className='container-fluid'>
              <div className='row justify-content-center'>
                <div className='col-10 text-center'>
                  <a href={donationUrl} className='link'>
                    Donate
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}
      </main>

      <style jsx>{`
        .community-intro,
        .community-voting-intro,
        .community-films,
        .community-faqs,
        .community-connected,
        .community-donate {
          margin: 100px 0;
        }

        .community-intro__copy,
        .community-voting-intro__copy,
        .community-connected__copy {
          margin-top: 30px;
        }

        .voting-dates {
          margin-top: 40px;
        }

        .voting-dates p {
          margin-bottom: 10px;
        }

        .faq-item {
          margin-bottom: 40px;
        }
      `}</style>
    </Page>
  )
}
